export const normalizeBrowserLangs = (langs: string[]) =>
  langs.map(lang => (lang.includes('-') ? lang.split('-')[0] : lang));
